import React, { useContext } from 'react';
import { motion } from "framer-motion";
import { black, blackblue } from './data';
import { ThemeContext } from '..';


export const LandingPage = () => {
    const darkMode = useContext(ThemeContext);
    return (
        <section className="hero is-link is-fullheight" id="home" style={{ background: darkMode ? black : blackblue }}>
            <div className="hero-head">
            </div>
            <div className="hero-body">
                <div className="container">
                    <div className="landing-page">
                        <ul>
                            <motion.div
                                animate={{
                                    x: 400,
                                    y: 0,
                                    scale: 1,
                                    rotate: 0,
                                }}
                            ><li className="t1 title" style={{ position: 'relative', left: "-400px" }}>
                                    Hello I'm <span style={{ fontWeight: "600", color: "lightblue" }}>Pravin</span>
                                </li>
                                <li className="t2 title" style={{ position: 'relative', left: "-400px" }}>
                                    Im a Full Stack developer and Freelancer
                            </li>
                            </motion.div>

                        </ul>

                    </div>

                </div>
            </div>

        </section>
    )
}